import { PerksbarContactEmail } from '@constants/perksbar';

export const FooterContent = [
  {
    title: 'About Us',
    href: '/about-us',
    links: [
      {
        text: 'Our Vision',
        href: '/about-us',
      },
    ],
  },
  {
    title: 'Our Solution',
    href: '/our-solution',
    links: [
      {
        text: 'Core Features',
        href: '/our-solution#core-features',
      },
      {
        text: 'Why PerksBar?',
        href: '/our-solution#why-perksbar',
      },
    ],
  },
  {
    title: 'Pricing',
    href: '/pricing',
    links: [
      {
        text: 'Our Pricing',
        href: '/pricing#price-plan',
      },
      {
        text: 'Frequently Asked Questions',
        href: '/pricing#faq',
      },
    ],
  },
  {
    title: 'Contact Us',
    href: '/schedule-a-demo',
    links: [
      {
        text: PerksbarContactEmail,
        href: `mailto:${PerksbarContactEmail}`,
      },
      {
        prefix: 'New Territories',
        text: 'Unit 1058, 10/F, Building 19W, No.19 Science Park West Avenue, Hong Kong Science Park, Pak Shek Kok, New Territories',
        href: 'https://goo.gl/maps/Ea36sRSFHSCrn3eY8',
      },
    ],
  },
];

export default FooterContent;
